import axios, { AxiosInstance } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { handleUnauthorized } from '../../utils/authSync';

const authEnabledServices: AxiosAPIService[] = [];

class AxiosAPIService {
  apiInstance: AxiosInstance;

  constructor(private baseURL: string) {
    this.apiInstance = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    authEnabledServices.push(this);

    this.apiInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          handleUnauthorized();
        }
        return Promise.reject(error);
      },
    );
  }

  public get api(): AxiosInstance {
    return this.apiInstance;
  }

  public setAuthToken(token: string, setToken?: Dispatch<SetStateAction<boolean>>): void {
    this.apiInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
    if (setToken) {
      setToken(true);
    }
  }

  public clearAuthToken(): void {
    delete this.apiInstance.defaults.headers.common.Authorization;
  }
}

export const DataAPIService = new AxiosAPIService(`${process.env.REACT_APP_DATA_ENDPOINT}/api/v1/fleets`);
export const ProfileAPIService = new AxiosAPIService(`${process.env.REACT_APP_PROFILE_ENDPOINT}/api/v1`);
export const VideoAPIService = new AxiosAPIService(`${process.env.REACT_APP_VIDEO_ENDPOINT}/api/v1`);
export const FotaAPIService = new AxiosAPIService(`${process.env.REACT_APP_FOTA_ENDPOINT}/api/v1`);
export const NotificationAPIService = new AxiosAPIService(`${process.env.REACT_APP_NOTIFICATION_ENDPOINT}/api/v1`);
export const GeofenceAPIService = new AxiosAPIService(`${process.env.REACT_APP_GEOFENCE_ENDPOINT}/api/v1`);
export const ReportAPIService = new AxiosAPIService(`${process.env.REACT_APP_REPORT_ENDPOINT}/api/v1`);

export function clearAllApiAuthTokens(): void {
  authEnabledServices.forEach((service) => {
    service.clearAuthToken();
  });
}
